import { Link, useMediaQuery } from '@material-ui/core';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import emailIcon from '../../../assets/images/ic_email.svg';
import phoneIcon from '../../../assets/images/ic_phone.svg';
import { version } from '../../../../package.json';
import { Container, PageContent } from './Content.styled';
import Survey from '../Survey';
import { BrandContext } from 'app/brandcontext/brandContext';

const Content = ({ children }) => {
  const isWideView = useMediaQuery('(min-width: 830px)');
  const { t } = useTranslation();

  const { brandName } = useContext(BrandContext);

  return (
    <Container>
      <PageContent isWideView={isWideView}>{children}</PageContent>
      <div className="support">
        <Survey />
        {brandName === 'smartboxbasel' ? (
          <>
            {t`Support`} [{t`workdays`} 8-12 & 14-17h]:
            <Link href="tel:0647859085" className="contact">
              <img src={phoneIcon} alt={"Phone icon"} />
              061 785 90 85
            </Link>
            <Link href="mailto:support@smartboxbasel.ch" className="contact">
              <img src={emailIcon} alt={"Email icon"} />
              support@smartboxbasel.ch
            </Link>
          </>
        ) : null}
        <div className={brandName === "salubox" ? "saluboxVersion" : "version"}>v{version}</div>
      </div>
    </Container>
  );
};

export default Content;
